'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var newsRecentPopularComponent = exports.newsRecentPopularComponent = {
    template: require('./news-recent-popular.html'),
    bindings: {
        recentNews: '<',
        popularNews: '<',
        currentTab: '@'
    },
    controllerAs: 'vm',
    controller: function controller() {

        var vm = this;

        //vm.currentTab = currentTab;
        vm.onClickTab = onClickTab;

        function onClickTab(tabId) {
            vm.currentTab = tabId;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/news/components/news-recent-popular.js
// module id = 947
// module chunks = 0